import * as actionTypes from "./actionTypes";

export const toggleMenu = () => ({ type: actionTypes.TOGGLE_MENU });

export const toggleResourceStats = () => ({ type: actionTypes.TOGGLE_RESOURCES_STATS });

export const openTooltip = (tooltipOptions: {}) => ({
  type: actionTypes.OPEN_TOOLTIP,
  tooltipOptions
});

export const closeTooltip = (tooltipName?: string) => ({
  type: actionTypes.CLOSE_TOOLTIP,
  tooltipName
});

export const openDialog = (dialogOptions: {}) => ({
  type: actionTypes.OPEN_DIALOG,
  dialogOptions
});

export const closeDialog = (dialogName?: string) => ({
  type: actionTypes.CLOSE_DIALOG,
  dialogName
});

export const openCityDialog = (dialogOptions: {}) => ({
  type: actionTypes.OPEN_CITY_DIALOG,
  dialogOptions
});

export const closeCityDialog = () => ({ type: actionTypes.CLOSE_CITY_DIALOG });

export const closeDialogs = () => ({ type: actionTypes.CLOSE_DIALOGS });
export const openContentPopup = (contentPopupOptions: {}) => ({
  type: actionTypes.OPEN_CONTENT_POPUP,
  contentPopupOptions
});

export const closeContentPopup = () => ({ type: actionTypes.CLOSE_CONTENT_POPUP });

export const toggleIdleState = (timeout?: number) => ({
  type: actionTypes.TOGGLE_IDLE_STATE,
  timeout
});

export const setError = (error?: string) => ({
  type: actionTypes.SET_ERROR,
  error
});

export const getTypehint = (searchArea: string, value: string) => ({
  type: actionTypes.GET_TYPEHINT,
  searchArea,
  value
});

export const setTypehint = (typeHints: string[] | null) => ({
  type: actionTypes.SET_TYPEHINT,
  typeHints
});
